module.exports = __webpack_public_path__ + "img/3.7c484360.jpg";